import { Link } from '../../Link/Link';
import { ProductDefault } from '../ProductDefault/ProductDefault';
import { ProductVariant } from '../ProductVariant/ProductVariant';

export interface Product extends ProductDefault, ProductVariant {
    id: string;
    slug: string;
    name: string;
    description: string;
    brand?: Link;
}

export enum ProductSeoAvailability {
    backOrder = 'https://schema.org/BackOrder',
    discontinued = 'https://schema.org/Discontinued',
    inStock = 'https://schema.org/InStock',
    inStoreOnly = 'https://schema.org/InStoreOnly',
    limitedAvailability = 'https://schema.org/LimitedAvailability',
    madeToOrder = 'https://schema.org/MadeToOrder',
    onlineOnly = 'https://schema.org/OnlineOnly',
    outOfStock = 'https://schema.org/OutOfStock',
    preOrder = 'https://schema.org/PreOrder',
    preSale = 'https://schema.org/PreSale',
    reserved = 'https://schema.org/Reserved',
    soldOut = 'https://schema.org/SoldOut',
}

export enum ProductSeoCondition {
    new = 'https://schema.org/NewCondition',
    damaged = 'https://schema.org/DamagedCondition',
    refurbished = 'https://schema.org/RefurbishedCondition',
    used = 'https://schema.org/UsedCondition',
}

export const productVariantSeparator = '--';
